import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Modal from '../../../shared/Modal';
import LanguageModal from '../../../shared/ModalComponents/LanguageModal';

const openModalConfirmation = () => {
  Modal({
    component: <LanguageModal />,
    width: '620px',
    padding: '17px',
  });
};

const LanguageButton = ({ showLanguagePrompt }) => {
  return (
    <IconWrapper onClick={() => openModalConfirmation()}>
      <LanguageIcon
        $showLanguagePrompt={showLanguagePrompt}
        alt="Language Picker"
      />
    </IconWrapper>
  );
};

LanguageButton.propTypes = {
  showLanguagePrompt: PropTypes.bool,
};

export default LanguageButton;

const LanguageIcon = styled.i`
  ${themeGet('mediaQueries.forMediumUp')} {
    display: block;
    &:hover {
      color: ${themeGet('colors.black.60')};
    }
  }

  ${({ $showLanguagePrompt }) =>
    $showLanguagePrompt &&
    css`
      color: ${themeGet('colors.primary.100')};

      &:hover {
        color: ${themeGet('colors.primary.120')};
      }
    `}
`;

LanguageIcon.defaultProps = {
  className: 'fa-regular fa-language fa-2x',
};

const IconWrapper = styled.div`
  ${themeGet('mediaQueries.forMediumUp')} {
    flex: 0;
    display: block;
    cursor: pointer;
    margin: 0px -10px 0px 20px;
  }
`;
